import { ipsos, supuesto } from ".";

// Lámina 100 (Vacaciones), base 400. Reusada también por la pestaña Personales de Viajes
// (CategoriaViajes) — una sola copia (10.1).
const P_FRECUENCIA = "¿Con qué frecuencia toma vacaciones?";
const P_TEMPORADA = "¿En qué momento del año prefiere tomarse vacaciones?";
const P_DESTINO = "¿Prefiere destinos nacionales o internacionales?";
const P_AEROLINEA = "¿Cuál es su aerolínea de preferencia?";

// factor = viajes por año (supuesto comercial derivado de la frecuencia Ipsos)
export const IPSOS_VACACIONES = {
  frecuenciaVacaciones: {
    variasVeces: {
      pct: ipsos(0.252, { lamina: 100, pregunta: P_FRECUENCIA, base: 400 }),
      factor: supuesto(3, { nota: "viajes por año" }),
      label: "Varias veces en el año",
    },
    dosVeces: {
      pct: ipsos(0.035, { lamina: 100, pregunta: P_FRECUENCIA, base: 400 }),
      factor: supuesto(2, { nota: "viajes por año" }),
      label: "2 veces al año",
    },
    unaVez: {
      pct: ipsos(0.601, { lamina: 100, pregunta: P_FRECUENCIA, base: 400 }),
      factor: supuesto(1, { nota: "viajes por año" }),
      label: "Una vez al año",
    },
    cadaDosAnos: {
      pct: ipsos(0.096, { lamina: 100, pregunta: P_FRECUENCIA, base: 400 }),
      factor: supuesto(0.5, { nota: "viajes por año" }),
      label: "Una vez cada dos años",
    },
    nunca: {
      pct: ipsos(0.016, { lamina: 100, pregunta: P_FRECUENCIA, base: 400 }),
      factor: supuesto(0, { nota: "no viaja" }),
      label: "Nunca ha tomado vacaciones",
    },
  },
  aerolineas: {
    Latam: ipsos(0.827, { lamina: 100, pregunta: P_AEROLINEA, base: 400 }),
    Sky: ipsos(0.068, { lamina: 100, pregunta: P_AEROLINEA, base: 400 }),
    JetSmart: ipsos(0.004, { lamina: 100, pregunta: P_AEROLINEA, base: 400 }),
    "Sin preferencia": ipsos(0.1, { lamina: 100, pregunta: P_AEROLINEA, base: 400 }),
  },
  tipoDestino: {
    Nacional: ipsos(0.548, { lamina: 100, pregunta: P_DESTINO, base: 400 }),
    Internacional: ipsos(0.437, { lamina: 100, pregunta: P_DESTINO, base: 400 }),
    Regional: ipsos(0.016, { lamina: 100, pregunta: P_DESTINO, base: 400 }),
  },
};

// Supuesto comercial — opciones de ticket promedio (CLP)
export const TICKETS_VACACIONES = [
  supuesto(300000, { nota: "ticket promedio de viaje" }),
  supuesto(500000, { nota: "ticket promedio de viaje" }),
  supuesto(1000000, { nota: "ticket promedio de viaje" }),
  supuesto(2000000, { nota: "ticket promedio de viaje" }),
];

export const TEMPORADA_OPCIONES = [
  { key: "Verano", pct: ipsos(0.546, { lamina: 100, pregunta: P_TEMPORADA, base: 400 }) },
  { key: "Otoño", pct: ipsos(0.204, { lamina: 100, pregunta: P_TEMPORADA, base: 400 }) },
  { key: "Invierno", pct: ipsos(0.153, { lamina: 100, pregunta: P_TEMPORADA, base: 400 }) },
  { key: "Primavera", pct: ipsos(0.097, { lamina: 100, pregunta: P_TEMPORADA, base: 400 }) },
];
